module.exports = __webpack_public_path__ + "img/angle-left.a85fb37b.svg";